import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const setPasswordReducer = createReducer<State, Actions>(initialState, {
  [actions.setPassword.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.setPassword.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.setPassword.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.setPassword.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default setPasswordReducer;
